var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4995 19.2628H1.94951C1.89651 19.2628 1.84551 19.2408 1.80851 19.2038C1.77051 19.1658 1.74951 19.1158 1.74951 19.0628V17.6118C1.74951 16.7818 2.34251 16.0498 3.25651 15.4278C4.88851 14.3138 7.52951 13.6118 10.4995 13.6118C10.9135 13.6118 11.2495 13.2758 11.2495 12.8618C11.2495 12.4488 10.9135 12.1118 10.4995 12.1118C7.17751 12.1118 4.23651 12.9428 2.41051 14.1878C1.01751 15.1378 0.249512 16.3448 0.249512 17.6118V19.0628C0.249512 19.5128 0.428512 19.9458 0.747512 20.2648C1.06651 20.5828 1.49851 20.7628 1.94951 20.7628C3.42851 20.7628 10.4995 20.7628 10.4995 20.7628C10.9135 20.7618 11.2495 20.4258 11.2495 20.0118C11.2495 19.5988 10.9135 19.2618 10.4995 19.2628Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4995 0.25C7.46351 0.25 4.99951 2.714 4.99951 5.75C4.99951 8.786 7.46351 11.25 10.4995 11.25C13.5355 11.25 15.9995 8.786 15.9995 5.75C15.9995 2.714 13.5355 0.25 10.4995 0.25ZM10.4995 1.75C12.7075 1.75 14.4995 3.542 14.4995 5.75C14.4995 7.958 12.7075 9.75 10.4995 9.75C8.29151 9.75 6.49951 7.958 6.49951 5.75C6.49951 3.542 8.29151 1.75 10.4995 1.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4995 12.938C14.5335 12.938 12.9375 14.534 12.9375 16.5C12.9375 18.466 14.5335 20.063 16.4995 20.063C18.4655 20.063 20.0625 18.466 20.0625 16.5C20.0625 14.534 18.4655 12.938 16.4995 12.938ZM16.4995 14.438C17.6375 14.438 18.5625 15.362 18.5625 16.5C18.5625 17.638 17.6375 18.563 16.4995 18.563C15.3615 18.563 14.4365 17.638 14.4365 16.5C14.4365 15.362 15.3615 14.438 16.4995 14.438Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2495 13.687V12C17.2495 11.586 16.9135 11.25 16.4995 11.25C16.0855 11.25 15.7495 11.586 15.7495 12V13.688C15.7495 14.101 16.0855 14.438 16.4995 14.438C16.9135 14.437 17.2495 14.101 17.2495 13.687Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0183 15.0421L20.2113 13.8481C20.5043 13.5561 20.5043 13.0801 20.2113 12.7881C19.9193 12.4951 19.4433 12.4951 19.1513 12.7881L17.9573 13.9811C17.6653 14.2741 17.6653 14.7491 17.9573 15.0421C18.2503 15.3341 18.7253 15.3341 19.0183 15.0421Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3115 17.25H20.9995C21.4135 17.25 21.7495 16.914 21.7495 16.5C21.7495 16.086 21.4135 15.75 20.9995 15.75H19.3115C18.8985 15.75 18.5625 16.086 18.5625 16.5C18.5615 16.914 18.8985 17.25 19.3115 17.25Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9573 19.0188L19.1513 20.2118C19.4433 20.5048 19.9193 20.5048 20.2113 20.2118C20.5043 19.9198 20.5043 19.4438 20.2113 19.1518L19.0183 17.9578C18.7253 17.6658 18.2503 17.6658 17.9573 17.9578C17.6653 18.2508 17.6653 18.7258 17.9573 19.0188Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7495 19.312V21C15.7495 21.414 16.0855 21.75 16.4995 21.75C16.9135 21.75 17.2495 21.414 17.2495 21V19.312C17.2495 18.899 16.9135 18.563 16.4995 18.562C16.0855 18.562 15.7495 18.899 15.7495 19.312Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9806 17.9578L12.7876 19.1518C12.4946 19.4438 12.4946 19.9198 12.7876 20.2118C13.0796 20.5048 13.5556 20.5048 13.8476 20.2118L15.0416 19.0188C15.3336 18.7258 15.3336 18.2508 15.0416 17.9578C14.7486 17.6658 14.2736 17.6658 13.9806 17.9578Z",
    fill: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6865 15.75H11.9995C11.5855 15.75 11.2495 16.086 11.2495 16.5C11.2495 16.914 11.5855 17.25 11.9995 17.25H13.6865C14.1005 17.25 14.4375 16.914 14.4365 16.5C14.4365 16.086 14.1005 15.75 13.6865 15.75Z",
    fill: "currentColor"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0416 13.9811L13.8476 12.7881C13.5556 12.4951 13.0796 12.4951 12.7876 12.7881C12.4946 13.0801 12.4946 13.5561 12.7876 13.8481L13.9806 15.0421C14.2736 15.3341 14.7486 15.3341 15.0416 15.0421C15.3336 14.7491 15.3336 14.2741 15.0416 13.9811Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSettings);
export default __webpack_public_path__ + "static/media/ProfileSettings.5a33dce73a91381076bb4eb5b61b98db.svg";
export { ForwardRef as ReactComponent };